import {Image, Text, TouchableOpacity, View} from 'react-native';
import SubjectList from './components/SubjectList';
import {useEffect, useRef, useState} from 'react';
import {useAppDispatch, useAppSelector} from '../../../store/hooks';
import {
  fetchBookVersions,
  fetchGrades,
  fetchPaperPreview,
  fetchPaperTypes,
  fetchSubjects,
  selectBookVersions,
  selectGrades,
  selectSubjects,
} from '../../../store/xueke';
import {
  hideGlobalLoading,
  showGlobalLoading,
} from '../../../components/Loading/GlobalLoading';
import {getUserInfo, selectUserInfo} from '../../../store/user';
import {
  GetPaperDetailParams,
  getXkwPapersGetForPhaseTesting,
  PapersForPhaseTestingParams,
  PapersForPhaseTestingRes,
  PapersForPhaseTestingResItem,
  updateXkwInfo,
  UpdateXkwInfoParams,
} from '../../../API/mylearn';
import BasicInfo from './components/BasicInfo';
import {createStyles} from '../../../utils/createStyles';
import Buttons from './components/Buttons';
import {jieduan} from './components/sceneType';
import TestList from './components/TestList';
import YearListModal from './components/yearsList';
import {useNavigation} from '@react-navigation/native';

const MyLearnBeikaoJieduan = () => {
  const dispatch = useAppDispatch();
  const navigation = useNavigation();
  const subjects = useAppSelector(selectSubjects);
  const userInfo = useAppSelector(selectUserInfo); // 用户信息
  const [currentSubjectId, setCurrentSubjectId] = useState(1);
  const [updateBasicInfoObjState, setUpdateBasicInfoObjState] = useState(true);
  const [basicInfoObj, setBasicInfoObj] = useState<UpdateXkwInfoParams>({});
  const [basicInfoName, setBasicInfoName] = useState('请选择教材版本');
  const [visible, setVisible] = useState(false);
  const grades = useAppSelector(selectGrades);
  const versions = useAppSelector(selectBookVersions);
  const [testList, setTestList] = useState<PapersForPhaseTestingResItem[]>([]); // 测试列表
  const [pageIndex, setPageIndex] = useState(1);
  const [yearListVisible, setYearListVisible] = useState(false);
  const [currentYear, setCurrentYear] = useState(0);
  const TestListRef = useRef(null);
  const [listDta, setListData] = useState<PapersForPhaseTestingRes>({});
  const changeYear = (year: number) => {
    setCurrentYear(year);
  };
  const changeSubject = (id: number) => {
    setCurrentSubjectId(id);
  };
  const senceType = [{name: '全部', id: 'all'}, ...jieduan.type];
  const [currentSecneType, setCurrentSecneType] = useState('all');
  const initBasicInfo = async () => {
    setUpdateBasicInfoObjState(true);
    showGlobalLoading({text: '加载中'});
    await dispatch(fetchPaperTypes()).unwrap(); // 获取所有类型
    await dispatch(fetchGrades()).unwrap(); // 获取所有年级
    dispatch(getUserInfo()) // 获取用户信息
      .unwrap()
      .then(res => {
        const grade_id = res.xkwGradeId
          ? res.xkwGradeId
          : res.grade
          ? res.grade
          : 0;
        const term = res.xkwTerm ? res.xkwTerm : 'LAST';
        dispatch(fetchSubjects(grade_id)) // 通过用户年级获取科目列表
          .unwrap()
          .then(async sub => {
            const subject_id = sub[0].id;
            const version_id = await getVersionId(grade_id, subject_id);
            setBasicInfoObj(prevBasicInfoObj => ({
              ...prevBasicInfoObj,
              grade_id: grade_id,
              term,
              version_id,
              subject_id,
            }));
            changeSubject(subject_id);
            setUpdateBasicInfoObjState(false);
            hideGlobalLoading();
            // });
          });
      });
  };
  const getVersionId = (grade_id: number, subject_id: number) => {
    return dispatch(
      fetchBookVersions({
        gradeId: grade_id,
        subjectId: subject_id,
      }),
    )
      .unwrap()
      .then(res => {
        const list = userInfo.xkwCoursesTextbookVersionsList;
        const version =
          list !== undefined &&
          list.find(
            item =>
              item.grade_id === grade_id && item.subject_id === subject_id,
          );
        if (version) {
          return version.version_id;
        } else {
          return res[0].id;
        }
      });
  };
  useEffect(() => {
    initBasicInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // 获取列表
  const getList = async () => {
    showGlobalLoading({text: '加载中'});
    try {
      const p: PapersForPhaseTestingParams = {
        grade_id: basicInfoObj.grade_id,
        version_id: basicInfoObj.version_id,
        term: basicInfoObj.term,
        page_index: pageIndex,
        page_size: 20,
        subject_id: currentSubjectId,
        sceneType: currentSecneType,
        levelType: '',
        years: currentYear ? (currentYear === 9999 ? [] : [currentYear]) : [],
      };
      const res = await getXkwPapersGetForPhaseTesting(p);
      setListData(res.data);
      if (!res.data) {
        setTestList([]);
        return;
      }
      if (pageIndex === 1) {
        setTestList(res.data.items);
        return;
      } else {
        setTestList([...testList, ...res.data.items]);
      }
    } catch (e) {
      console.log(e);
    } finally {
      hideGlobalLoading();
    }
  };
  const loadMore = () => {
    console.log('loadMore', listDta.total_size, testList.length);
    if (testList.length === 0) {
      return;
    }
    if (listDta.total_page === pageIndex) {
      return;
    }
    if (listDta.total_size <= testList.length) {
      return;
    }
    setPageIndex(prevState => prevState + 1);
  };
  useEffect(() => {
    console.log('pageIndex', pageIndex);
    if (updateBasicInfoObjState) {
      return;
    }
    getList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageIndex]);
  // useEffect(() => {
  //   if (currentYear === 0) {
  //     return;
  //   }
  //   console.log(currentYear, '1');
  //   setPageIndex(1);
  //   getList();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [currentYear]);
  useEffect(() => {
    if (updateBasicInfoObjState) {
      return;
    }
    TestListRef.current?.scrollToTop();
    if (pageIndex !== 1) {
      console.log(TestListRef.current);
      setPageIndex(1);
      return;
    }
    getList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentSecneType, currentYear]);
  const toggleOverlay = () => {
    setVisible(!visible);
    // StatusBar.setHidden(true);
  };
  const handleButtonPress = (
    title: string,
    basicInfo: {grade_id: number; term: string; version_id: number},
  ) => {
    // setBasicInfoName(title);
    dispatch(fetchSubjects(basicInfo.grade_id));
    setVisible(false);
    updatePreferences({
      grade_id: basicInfo.grade_id,
      term: basicInfo.term,
      subject_id: currentSubjectId,
      version_id: basicInfo.version_id,
    });
  };
  // 更新偏好设置
  const updatePreferences = async (data: UpdateXkwInfoParams) => {
    try {
      const res = await updateXkwInfo(data);
      if (res.status === 200) {
        setBasicInfoObj({
          subject_id: currentSubjectId,
          grade_id: res.data.xkwGradeId,
          term: res.data.xkwTerm,
          version_id: data.version_id,
        });
      }
    } catch (e) {
      console.log(e);
    }
  };
  // 根据用户的信息获取树状结构
  useEffect(() => {
    console.log('basicInfoObjChange', basicInfoObj);
    // if (updateBasicInfoObjState) {
    //   return;
    // }
    if (!basicInfoObj.subject_id) {
      return;
    }
    getList();
    const gradeName = grades.find(
      item => item.id === basicInfoObj.grade_id,
    )?.name;
    const termName = basicInfoObj.term === 'LAST' ? '上学期' : '下学期';
    const version = versions.find(i => i.id === basicInfoObj.version_id);
    const versionName = version ? version.name : versions[0].name;
    console.log(
      'setBasicInfoName',
      `${versionName}    |   ${gradeName} ${termName}`,
    );
    setBasicInfoName(`${versionName}    |   ${gradeName} ${termName}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [basicInfoObj]);
  //  切换学科修改年级版本
  useEffect(() => {
    console.log(currentSubjectId);
    if (basicInfoObj.grade_id != null) {
      getVersionId(basicInfoObj.grade_id, currentSubjectId).then(res => {
        setBasicInfoObj(prevState => {
          return {
            ...prevState,
            version_id: res,
            subject_id: currentSubjectId,
          };
        });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentSubjectId]); // 当前科目或类型发生改变时触发;
  // 提交试卷
  const submitPaper = async (item: PapersForPhaseTestingResItem) => {
    console.log(item);
    showGlobalLoading({text: '加载中'});
    try {
      const p: {paperId: string} = {
        paperId: item.id,
      };
      const params: GetPaperDetailParams = {
        paper_id: item.id,
        moduleType: 'phaseTesting',
        sceneType: currentSecneType,
        subject_id: currentSubjectId,
        grade_id: basicInfoObj.grade_id,
        catalog_ids: [],
        formula_pic_format: '',
      };
      dispatch(fetchPaperPreview(p))
        .unwrap()
        .then(res => {
          if (res) {
            console.log(111, res);
            // @ts-ignore
            navigation.navigate('PaperPreview', params);
          }
        });
    } catch (e) {
      console.log(e);
    } finally {
      hideGlobalLoading();
    }
  };
  return (
    <>
      <View style={styles.ViewBox}>
        <SubjectList
          subjects={subjects}
          changeSubject={changeSubject}
          currentSubjectId={currentSubjectId}
        />
        <View style={styles.ViewBoxCon}>
          <BasicInfo
            basicInfoName={basicInfoName}
            basicInfoObj={basicInfoObj}
            userInfo={userInfo}
            currentSubjectId={currentSubjectId}
            visible={visible}
            handleButtonPress={handleButtonPress}
            toggleOverlay={toggleOverlay}
          />
          <View style={styles.ViewBoxMain}>
            <View style={styles.ViewBoxMainLeft}>
              <Buttons
                BtnList={senceType}
                currentSenceType={currentSecneType}
                setCurrentSenceType={setCurrentSecneType}
              />
            </View>
            <View style={styles.ViewBoxMainRight}>
              <TouchableOpacity
                onPress={() => {
                  setYearListVisible(true);
                }}
                style={styles.ViewBoxMainRightTop}>
                <Text style={styles.ViewBoxMainRightTopText}>
                  {currentYear === 9999 || !currentYear
                    ? '年份'
                    : currentYear + '年'}
                </Text>
                <Image
                  style={styles.ViewBoxMainRightTopIcon}
                  source={{
                    uri: 'https://zijinshe-media.oss-cn-beijing.aliyuncs.com/webapp/classroom/mylearn/bk/mylearn_beikai_bottomjt_.png',
                  }}
                />
              </TouchableOpacity>
              <YearListModal
                onBackdropPress={() => {
                  setYearListVisible(false);
                }}
                year={currentYear}
                changeYear={changeYear}
                visible={yearListVisible}
              />
              <View style={styles.ViewBoxMainRightList}>
                <TestList
                  ref={TestListRef}
                  testList={testList}
                  loadMore={loadMore}
                  submitPaper={submitPaper}
                  footer={() => {
                    return (
                      <>
                        {testList.length !== 0 &&
                          (testList.length >= listDta.total_size ||
                            pageIndex === listDta.total_page) && (
                            <View
                              style={{
                                justifyContent: 'center',
                                alignItems: 'center',
                              }}>
                              <Text style={{color: '#999'}}>
                                {' '}
                                -- 没有更多了 --{' '}
                              </Text>
                            </View>
                          )}
                      </>
                    );
                  }}
                />
              </View>
            </View>
          </View>
        </View>
      </View>
    </>
  );
};
const styles = createStyles({
  ViewBox: {
    flex: 1,
    backgroundColor: '#EAF1FF',
    paddingHorizontal: '2.3rem',
    paddingBottom: '2.3rem',
  },
  ViewBoxCon: {
    flex: 1,
    marginTop: '1.8rem',
  },
  ViewBoxMain: {
    flex: 1,
    // marginTop: '0.85rem',
    flexDirection: 'row',
  },
  ViewBoxMainLeft: {
    width: '10.7rem',
  },
  ViewBoxMainRight: {
    flex: 1,
    backgroundColor: '#fff',
    marginLeft: '1.55rem',
    borderRadius: '1rem',
    paddingHorizontal: '2rem',
    paddingBottom: '2rem',
  },
  ViewBoxMainRightTop: {
    marginTop: '1.4rem',
    flexDirection: 'row',
    alignItems: 'center',
  },
  ViewBoxMainRightTopText: {
    fontSize: '1.4rem',
    color: '#3d3d3d',
    fontWeight: '500',
    marginLeft: '0.5rem',
    marginRight: '1.95rem',
  },
  ViewBoxMainRightTopIcon: {
    width: '1.25rem',
    height: '1.25rem',
  },
  ViewBoxMainRightList: {
    flex: 1,
    marginTop: '1.2rem',
    backgroundColor: '#F4F7FF',
    borderRadius: '1rem',
    padding: '1.4rem',
  },
});
export default MyLearnBeikaoJieduan;
